import { FC } from 'react';
import EditorImg from 'lowcode/components/EditorImg';
import styled from './index.module.scss';
import { useLang } from '@/i18n';

interface IProps {
    code: string;
}

const Coupon: FC<IProps> = ({ code }) => {
    const { t } = useLang('membersday.return.tradein');

    return (
        <div className={styled.Coupon}>
            <h6 className="coupon_title">{t('coupon_title')}</h6>
            <div className="coupon_box">
                <div className="left">{t('coupon')}</div>
                <div className="right">
                    <EditorImg
                        pc={'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1710758358213/Frame%201000008083%20(1).png'}
                        h5={'https://ecoflow-service-eu-cdn.ecoflow.com/configurable/images/1711616601527/Frame%201000008083.png'}
                    />
                    <span>{t('coupon_name')}</span>
                </div>
            </div>
            <p className="coupon_code">
                {t.rich('coupon_code', {
                    code: () => <span>{code}</span>,
                })}
            </p>
            <p className="coupon_tips">{t('coupon_tips')}</p>
        </div>
    );
};

export default Coupon;
